<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{
                        $t(
                            isUpdate
                                ? 'edit-vinculo-prazo-pagamento'
                                : 'insert-vinculo-prazo-pagamento'
                        )
                    }}
                </h1>
                <span v-if="assprazopagto.prazopagto && assprazopagto.prazopagto != null">
                    <h1 class="title">
                        {{ $t('prazopagto') }}: {{ assprazopagto.prazopagto.descricao }}
                    </h1>
                </span>
                <span v-else>
                    <h1 class="title">{{ $t('prazopagto') }}: {{ selected.descricao }}</h1>
                </span>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="cancelar()">
                    {{ $t('cancelar') }}
                </button>
                <button
                    v-if="!desabilitar || !isUpdate"
                    class="save-btn"
                    type="button"
                    @click="save"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>
        <br />
        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-4">
                    <v-money
                        :id="generateId(1)"
                        ref="reajusteInput"
                        title="reajuste"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.reajuste"
                        :invalid="isNull(assprazopagto.reajuste)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-reajuste"
                        tooltipSize="is-large"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(2)"
                        ref="margempedidoInput"
                        title="margempedido"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.margempedido"
                        :invalid="isNull(assprazopagto.margempedido)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-margempedido"
                        tooltipSize="is-large"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(3)"
                        ref="valorpedminimoInput"
                        title="valorpedminimo"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.valorpedminimo"
                        :invalid="isNull(assprazopagto.valorpedminimo)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-valorpedminimo"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(4)"
                        ref="indicepedidoInput"
                        title="indicepedido"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.indicepedido"
                        :invalid="isNull(assprazopagto.indicepedido)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-indicepedido"
                        tooltipSize="is-large"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(5)"
                        ref="margemmediapedidoInput"
                        title="margemmediapedido"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.margemmediapedido"
                        :invalid="isNull(assprazopagto.margemmediapedido)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-margemmediapedido"
                        tooltipSize="is-large"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-money
                        :id="generateId(6)"
                        ref="valorpedmaximoInput"
                        title="valorpedmaximo"
                        placeholder="placeholder-preencha"
                        :msg="'msg-campo-obrigatorio'"
                        v-model="assprazopagto.valorpedmaximo"
                        :invalid="isNull(assprazopagto.valorpedmaximo)"
                        :max="9999999"
                        :required="true"
                        tooltipLabel="informacao-valorpedmaximo"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-6">
                    <vss-select
                        :id="generateId(13)"
                        ref="campanhaInput"
                        title="campanha"
                        :searchable="false"
                        :options="campanhas"
                        v-model="campanha"
                        tooltipLabel="informacao-campanha"
                        tooltipPosition="is-right"
                        :clearable="true"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(9)"
                        ref="ignoraregrasaldoclienteInput"
                        title="ignoraregrasaldocliente"
                        :searchable="false"
                        :options="simNao"
                        v-model="ignoraregrasaldocliente"
                        class="no-clear"
                        tooltipLabel="informacao-ignoraregrasaldocliente"
                        tooltipPosition="is-top"
                        :mlLabels="true"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(10)"
                        ref="flexivelInput"
                        title="flexivel"
                        :searchable="false"
                        :options="simNao"
                        v-model="flexivel"
                        class="no-clear"
                        tooltipLabel="informacao-flexivel"
                        tooltipPosition="is-left"
                        :mlLabels="true"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(11)"
                        ref="validaparcelasflexivelInput"
                        title="validaparcelasflexivel"
                        :searchable="false"
                        :options="simNao"
                        v-model="validaparcelasflexivel"
                        class="no-clear"
                        tooltipLabel="informacao-validaparcelasflexivel"
                        tooltipPosition="is-right"
                        :mlLabels="true"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <vss-select
                        :id="generateId(12)"
                        ref="prazofixoInput"
                        title="prazofixo"
                        :searchable="false"
                        :options="simNao"
                        v-model="prazofixo"
                        class="no-clear"
                        tooltipLabel="informacao-prazofixo"
                        tooltipPosition="is-top"
                        :mlLabels="true"
                        @onBlurFunction="sendIsChanged()"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-4">
                    <v-input
                        :id="generateId(7)"
                        ref="colunavendaInput"
                        title="colunavenda"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.colunavenda"
                        :invalid="isNull(assprazopagto.colunavenda)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-colunavenda"
                        tooltipPosition="is-top"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
            </div>
        </div>
        <div class="page-container form-columns-fit mt-4 mb-4">
            <div class="columns is-flex-wrap">
                <div class="column is-3">
                    <v-input
                        :id="generateId(8)"
                        ref="colunadescontoInput"
                        title="colunadesconto"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.colunadesconto"
                        :invalid="isNull(assprazopagto.colunadesconto)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-colunadesconto"
                        tooltipPosition="is-right"
                        :disabled="desabilitar && !isInsert"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(14)"
                        ref="prazoinicialInput"
                        title="prazoinicial"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.prazoinicial"
                        :invalid="isNull(assprazopagto.prazoinicial)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-prazoinicial"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                        :disabled="desabilitar && !isInsert"
                        @onBlurFunction="
                            defaultValue(assprazopagto.prazoinicial, 'prazoinicial', 0)
                        "
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(15)"
                        ref="prazomaximoInput"
                        title="prazomaximo"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.prazomaximo"
                        :invalid="isNull(assprazopagto.prazomaximo)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-prazomaximo"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                        :disabled="desabilitar && !isInsert"
                        @onBlurFunction="defaultValue(assprazopagto.prazomaximo, 'prazomaximo', 0)"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(16)"
                        ref="prazominimoInput"
                        title="prazominimo"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.prazominimo"
                        :invalid="isNull(assprazopagto.prazominimo)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-prazominimo"
                        tooltipSize="is-large"
                        tooltipPosition="is-left"
                        :disabled="desabilitar && !isInsert"
                        @onBlurFunction="defaultValue(assprazopagto.prazominimo, 'prazominimo', 0)"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(17)"
                        ref="prazomedioInput"
                        title="prazomedio"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.prazomedio"
                        :invalid="isNull(assprazopagto.prazomedio)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-prazomedio"
                        tooltipSize="is-small"
                        tooltipPosition="is-top"
                        :disabled="desabilitar && !isInsert"
                        @onBlurFunction="defaultValue(assprazopagto.prazomedio, 'prazomedio', 0)"
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(18)"
                        ref="prazomediomaximoInput"
                        title="prazomediomaximo"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.prazomediomaximo"
                        :invalid="isNull(assprazopagto.prazomediomaximo)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-prazomediomaximo"
                        tooltipSize="is-large"
                        tooltipPosition="is-top"
                        :disabled="desabilitar && !isInsert"
                        :hasDefaultValue="true"
                        @onBlurFunction="
                            defaultValue(assprazopagto.prazomediomaximo, 'prazomediomaximo', 0)
                        "
                    />
                </div>
                <div class="column is-3">
                    <v-input
                        :id="generateId(19)"
                        ref="qtdeparcelasInput"
                        title="qtdeparcelas"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        v-model="assprazopagto.qtdeparcelas"
                        :invalid="isNull(assprazopagto.qtdeparcelas)"
                        :useMask="true"
                        :vMask="['####']"
                        tooltipLabel="informacao-qtdeparcelas"
                        tooltipSize="is-large"
                        tooltipPosition="is-top"
                        :disabled="desabilitar && !isInsert"
                        @onBlurFunction="
                            defaultValue(assprazopagto.qtdeparcelas, 'qtdeparcelas', 1)
                        "
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssPrazoPagamentoEmpresa from '@/services/vendas/empresa/abas/AssPrazoPagamentoEmpresaService';
import CampanhaService from '@/services/vendas/CampanhaService';
import Message from '@/models/Message';

export default {

    props: {
        selected: {
            type: Object,
            default: () => {},
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
        desabilitar: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            service: new AssPrazoPagamentoEmpresa(this.$http, this.$router),
            serviceCampanha: new CampanhaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            assprazopagto: {
                idassprazopagtoempresa: null,
                idprazopagto: null,
                idempresa: null,
                reajuste: 0,
                margempedido: 0,
                valorpedminimo: 0,
                indicepedido: 0,
                margemmediapedido: 0,
                colunavenda: 1,
                colunadesconto: 1,
                qtdeparcelas: 1,
                prazoinicial: 0,
                prazomaximo: 0,
                prazominimo: 0,
                prazomediomaximo: 0,
                prazomedio: 0,
                valorpedmaximo: 0,
                idcampanha: 0,
                prazofixo: 0,
                flexivel: 'N',
                validaparcelasflexivel: 'N',
                ignoraregrasaldocliente: 'N',
                prazopagto: null,
            },
            flexivel: null,
            validaparcelasflexivel: null,
            ignoraregrasaldocliente: null,
            prazofixo: null,
            simNao: [
                { id: 0, label: 'nao' },
                { id: 1, label: 'sim' },
            ],
            campanhas: [],
            campanha: null,
            colunasvendas: [
                { id: 1, label: 'valor1' },
                { id: 2, label: 'valor2' },
                { id: 3, label: 'valor3' },
                { id: 4, label: 'valor4' },
                { id: 5, label: 'valor5' },
                { id: 6, label: 'valor6' },
                { id: 7, label: 'valor7' },
            ],
            colunavenda: { id: 1, label: 'valor1' },
            colunasdesconto: [
                { id: 1, label: 'desconto1' },
                { id: 2, label: 'desconto2' },
                { id: 3, label: 'desconto3' },
                { id: 4, label: 'desconto4' },
                { id: 5, label: 'desconto5' },
                { id: 6, label: 'desconto6' },
                { id: 7, label: 'desconto7' },
            ],
            colunadesconto: { id: 1, label: 'desconto1' },

            isVenda: this.$route.meta.contexto == 'vendas',

            // @71071 - variável que controla algumas ações até os dados serem carregados na edição
            isLoadingEdit: false,
        };
    },
    created() {
        this.$emit('isChangedModal', false);
        this.carregarDadosCampanha();
        this.flexivel = this.simNao[0];
        this.validaparcelasflexivel = this.simNao[0];
        this.ignoraregrasaldocliente = this.simNao[0];
        this.prazofixo = this.simNao[0];
        this.assprazopagto.idempresa = this.selected.idempresa;
        this.assprazopagto.idprazopagto = this.selected.idprazopagto;
        if (this.selected.idassprazopagtoempresa != null) {
            this.carregarDados(this.selected.idassprazopagtoempresa);
        }
    },
    // @71071 - Emite ao componente pai se houve alteração em um campo input
    watch: {
        assprazopagto: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.$emit('isChangedModal', true);
                }
            },
        },
    },
    methods: {
        carregarDados(id) {
            this.isLoadingEdit = true;
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.assprazopagto = value.content;
                    this.flexivel = this.simNao[value.content.flexivel == 'N' ? 0 : 1];
                    this.validaparcelasflexivel = this.simNao[
                        value.content.validaparcelasflexivel == 'N' ? 0 : 1
                    ];
                    this.ignoraregrasaldocliente = this.simNao[
                        value.content.ignoraregrasaldocliente == 'N' ? 0 : 1
                    ];
                    this.prazofixo = this.simNao[value.content.prazofixo];
                    this.colunavenda = this.colunasvendas.find(
                        (f) => f.id == value.content.colunavenda
                    );
                    this.colunadesconto = this.colunasdesconto.find(
                        (f) => f.id == value.content.colunadesconto
                    );
                    if (value.content.campanha) {
                        this.campanha = this.campanhas.filter(
                            (f) => f.id == value.content.campanha.id
                        )[0];
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.$emit('isChangedModal', false);
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        carregarDadosCampanha() {
            this.isLoadingEdit = true;
            this.serviceCampanha
                .findAllCombo('')
                .then((body) => {
                    return body.content.map((i) => {
                        return {
                            id: i.id,
                            label: i.descricao,
                        };
                    });
                })
                .then((value) => {
                    this.campanhas = value;
                    this.campanha = this.campanhas.find((e) => e.id === this.selected.idcampanha);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    this.$emit('isChangedModal', false);
                    this.isLoadingEdit = false;
                });
        },

        generateId(numberId) {
            return this.$route.name + '-assprazopagto-' + numberId;
        },
        save() {
            this.isLoading = true;

            let tempAssprazopagto = Object.assign({}, this.assprazopagto);
            if (this.campanha != null) {
                tempAssprazopagto.idcampanha = this.campanha.id;
            }
            tempAssprazopagto.prazofixo = this.prazofixo.id;
            tempAssprazopagto.flexivel = this.flexivel.id == 0 ? 'N' : 'S';
            tempAssprazopagto.validaparcelasflexivel =
                this.validaparcelasflexivel.id == 0 ? 'N' : 'S';
            tempAssprazopagto.ignoraregrasaldocliente =
                this.ignoraregrasaldocliente.id == 0 ? 'N' : 'S';
            tempAssprazopagto.colunavenda = this.colunavenda.id;
            tempAssprazopagto.colunadesconto = this.colunadesconto.id;

            this.savePPM(tempAssprazopagto)
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message('error', `${value.message}`, true));
                    } else {
                        this.$emit('isChangedModal', false);
                        this.$root.showMessage(
                            'success',
                            this.assprazopagto.idassprazopagtoempresa != null
                                ? 'msg-sucesso-ao-editar-associcao'
                                : 'msg-sucesso-ao-adicionar-associacao'
                        );
                        setTimeout(() => {
                            this.$emit('fecharModal', true);
                        }, 200);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            this.isLoading = false;
        },
        savePPM(assprazopagto) {
            if (this.isVenda) return this.service.saveVendas(assprazopagto);
            else return this.service.saveAgro(assprazopagto);
        },
        defaultValue(value, refs, defaultValue) {
            if (this.isNull(value) || +value < +defaultValue) {
                this.assprazopagto[refs] = defaultValue;
            }
        },
        cancelar() {
            this.$emit('promptChangeTab', true);
        },
        // @71071 - Emite ao componente pai se houve alteração em um campo select
        sendIsChanged() {
            if (!this.isLoadingEdit) this.$emit('isChangedModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;
}
</style>
